import React from 'react';

const SectionHeader = ({ title }) => {
  return (
    <div className="mb-8 relative">
      <h2 className="text-3xl font-bold text-[#2978C8] dark:text-[#4f9cf9] inline-block relative z-10">
        {title}
        <span className="absolute -bottom-1 left-0 w-full h-1 bg-gradient-to-r from-[#2978C8] to-[#294C6F] dark:from-[#4f9cf9] dark:to-[#3a6ca0]"></span>
      </h2>
    </div>
  );
};

export default SectionHeader; 